// extracted by mini-css-extract-plugin
export default {"formContents":"edit_formContents__TRsaE"};